"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _selectInfiniteScroll["default"];
  }
});

var _selectInfiniteScroll = _interopRequireDefault(require("./selectInfiniteScroll"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }